import {
    Zap,
    Users,
    MessagesSquare,
    SlidersHorizontal,
    TrendingUp,
    ShieldCheck,
} from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const TINTS = [
    "bg-tang",
    "bg-hl-pink",
    "bg-hl-cyan",
    "bg-hl-lav",
    "bg-hl-pink",
    "bg-hl-cyan",
];

const BENEFITS = [
    {
        icon: Zap,
        title: "Szybsza reakcja",
        text: "W trudnym momencie nie szukasz w głowie ratunku - masz gotowy scenariusz działania.",
        img: "/images/benefits/b1.webp",
        alt: "Nauczycielka prowadząca zajęcia z grupą dorosłych",
    },
    {
        icon: Users,
        title: "Wszyscy w rozmowie",
        text: "Łatwiej zaangażujesz cichych uczniów i wyważysz tych, którzy dominują.",
        img: "/images/benefits/b2.webp",
        alt: "Grupa dorosłych uczniów rozmawia przy wspólnym stole",
    },
    {
        icon: MessagesSquare,
        title: "Rozmowa bez przestojów",
        text: "Poprowadzisz konwersację tak, żeby miała dynamikę i nie zamieniała się w przesłuchanie.",
        img: "/images/benefits/b3.webp",
        alt: "Uczniowie w swobodnej rozmowie podczas zajęć",
    },
    {
        icon: SlidersHorizontal,
        title: "Lekcja pod poziom grupy",
        text: "Dostosujesz zajęcia do różnych poziomów i potrzeb - także w grupach firmowych.",
        img: "/images/benefits/b4.webp",
        alt: "Prowadząca prezentuje materiał grupie w nowoczesnym biurze",
    },
    {
        icon: TrendingUp,
        title: "Rozmowy o postępach",
        text: "Nauczysz się rozmawiać z dorosłym uczniem o jego postępach i oczekiwaniach.",
        img: "/images/benefits/b5.webp",
        alt: "Rozmowa jeden na jeden przy laptopie i kawie",
    },
    {
        icon: ShieldCheck,
        title: "Spokój i pewność",
        text: "Wchodzisz na zajęcia z poczuciem, że masz plan - nawet gdy lekcja pójdzie nie po Twojej myśli.",
        img: "/images/benefits/b6.webp",
        alt: "Nauczycielka spokojnie przygotowuje notatki do lekcji",
    },
];

export const Benefits = () => (
    <section id="co-otrzymujesz" data-testid="benefits-section" className="py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <SectionHeading
                kicker="Co zyskujesz"
                title="Nie będziesz już za każdym razem wymyślać rozwiązania od zera"
            />
            <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {BENEFITS.map((b, i) => (
                    <Reveal key={b.title} delay={(i % 3) * 0.08}>
                        <article
                            data-testid={`benefit-card-${i + 1}`}
                            className={`group h-full rounded-2xl p-4 pb-7 flex flex-col transition-all duration-300 hover:-translate-y-1 hover:shadow-card ${TINTS[i]}`}
                        >
                            <img
                                src={b.img}
                                alt={b.alt}
                                loading="lazy"
                                className="w-full h-40 object-cover rounded-xl"
                            />
                            <span className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-white text-ink shadow-sm -mt-6 ml-3 relative z-10 transition-colors duration-300 group-hover:bg-ink group-hover:text-white">
                                <b.icon className="w-6 h-6" />
                            </span>
                            <div className="px-3">
                                <h3 className="font-display uppercase mt-4 text-lg font-bold text-ink leading-tight">
                                    {b.title}
                                </h3>
                                <p className="mt-2 text-sm text-ink/70 leading-relaxed">{b.text}</p>
                            </div>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
